module.exports = __webpack_public_path__ + "img/book_scan.8efa727b.png";